import React from 'react';
//import react router dom
import {BrowserRouter as Router, Route, Routes}  from 'react-router-dom';

//import pages
import Home from './pages/Home';
import ProductDetails from './pages/ProductDetails';
import {Products} from './pages/Products'
//import Components
import SideBar from './components/Sidebar';
import Header from './components/Header';
import Footer from './components/Footer';


import { PayPalScriptProvider } from '@paypal/react-paypal-js';
const App = () => {
  const initialOptions = {
    'client-id': process.env.REACT_APP_PAYPAL_CLIENT_ID,
    currency: "USD",
    intent: "capture",
  };
  return <div className='overflow-hidden'>
    <PayPalScriptProvider deferLoading={false} options={initialOptions}>
        <Router>
          <Header />
          <Routes>
            <Route path='/' element={<Home />} />
            <Route path='/product/:id' element={<ProductDetails />} />
            <Route path='/products' element={<Products />} />
          </Routes>
          <SideBar />
          <Footer />
        </Router>
      
    </PayPalScriptProvider>
      
  </div>;
};

export default App;
